export default __webpack_public_path__ + "static/media/trending-bg.4c77db52.png";